import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Card, { CardContent, CardActions, CardHeader } from "material-ui/Card";
import Collapse from "material-ui/transitions/Collapse";
import Button from "material-ui/Button";
import CenteredProgress from "./CenteredProgress";

const styles = theme => ({
  card: {
    marginBottom: 20
  },

  cardHeader: {
    alignItems: "flex-start",
    marginBottom: 0,
    paddingBottom: 0
  },
  flexGrow: { flex: "1 1 auto" },

  actions: {
    margin: 0,
    borderTopWidth: 1,
    borderTopColor: theme.palette.common.faintBlack,
    borderTopStyle: "solid",
    height: 30
  }
});

class OvInfoCard extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
    this.handleExpandClick = this.handleExpandClick.bind(this);
  }

  handleExpandClick() {
    this.setState({ expanded: !this.state.expanded });
  }

  renderContent() {
    if (this.props.loading) {
      return (
         <CenteredProgress /> 
      );
    }
    return <CardContent>{this.props.content}</CardContent>;
  }

  renderExpandButton() {
    let { expandLabel, contractLabel } = this.props;
    if (!expandLabel) {
      return null;
    }
    if (!contractLabel) {
      contractLabel = expandLabel;
    }

    return (
      <Button color="primary" onClick={this.handleExpandClick}>
        {this.state.expanded ? contractLabel : expandLabel}
      </Button>
    );
  }

  render() {
    const { classes, title } = this.props;

    return (
      <Card className={classes.card}>
        <CardHeader className={classes.cardHeader} title={title} />

        {this.renderContent()}

        <CardActions disableActionSpacing className={classes.actions}>
          {this.renderExpandButton()}

          <div className={classes.flexGrow} />

          {this.props.actions}
        </CardActions>

        <Collapse
          in={this.state.expanded}
          unmountOnExit
        >
          <CardContent>{this.props.expandedContent}</CardContent>
        </Collapse>
      </Card>
    );
  }
}

OvInfoCard.propTypes = {
  loading: PropTypes.bool.isRequired,
  fetched: PropTypes.number,
  total: PropTypes.number,
  title: PropTypes.string.isRequired,
  actions: PropTypes.element,
  content: PropTypes.element,
  expandedContent: PropTypes.element,
  expandLabel: PropTypes.string,
  contractLabel: PropTypes.string
};

export { OvInfoCard };

export default withStyles(styles, { name: "OvInfoCard" })(OvInfoCard);



// WEBPACK FOOTER //
// ./src/OvInfoCard.js